{ getValidAncestor } = require("utils/messaging")

# For external URLs, send an event for the parent application to navigate.
openExternalUrl = (externalUrl) ->
  if window.ED_LMS_PREVIEW or window.ED_PUBLIC_PREVIEW
    targetOrigin = getValidAncestor()
    window.parent.postMessage({
      type: "open-external-url",
      value: externalUrl
    }, targetOrigin) unless !targetOrigin
  else if window.ED_SCORM or window.ENGINE_PREVIEW
    window.open(externalUrl, "_blank")
  else 
    Application.publish("event:url-open")
      url: externalUrl
  return false

module.exports = {
  openExternalUrl
}